import { fetchWrapper } from '@/helpers';
const ruta = process.env.VUE_APP_ROOT_API;

export default class TipoDocumentoIdentidadService {
  async getAllTipoDocumentoIdentidad(){
    const tipoDocumentoIdentidad = await fetchWrapper.get(`${ruta}/tipo_documento_identidad`);
    return tipoDocumentoIdentidad;
  }
}